import { useState, useCallback } from 'react';
import { studentAPI } from '../services/api';

export const useStudentPromotion = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const getStudentsForPromotion = useCallback(async (classStreamId) => {
    try {
      setLoading(true);
      setError(null);
      const response = await studentAPI.getStudentsForPromotion(classStreamId);
      return response.data || [];
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to fetch students');
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  const previewPromotion = useCallback(async (promotions) => {
    try {
      setLoading(true);
      setError(null);
      const response = await studentAPI.previewPromotion({ promotions });
      return response.data;
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to preview promotion');
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  const executePromotion = useCallback(async (promotions) => {
    try {
      setLoading(true);
      setError(null);
      const response = await studentAPI.executePromotion({ promotions });
      return response.data;
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to execute promotion');
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    loading,
    error,
    getStudentsForPromotion,
    previewPromotion,
    executePromotion,
  };
};